import React from 'react';

import withCard from './WithCard';
import LongText from '../../../Types/Components/LongText';

const LongTextCard = (props) => {
  return <LongText {...props} />
}

export default withCard(LongTextCard);